import { usePreviewPanelsContext } from "../preview-panel-context";

export const useIsPreviewPanelOpen = (panelId?: string): boolean => {
	const context = usePreviewPanelsContext();
	return panelId ? context?.state.panel?.id === panelId : context?.state.panel != null;
};
